import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getPublicQuests, submitQuestProof } from '../api/projects';
import Navbar from '../components/Navbar';
import { Helmet } from 'react-helmet-async';

const PLATFORM_STYLES = {
    twitter:  { label: '𝕏 Twitter',  color: '#1DA1F2', bg: 'rgba(29,161,242,0.08)',  border: 'rgba(29,161,242,0.2)'  },
    telegram: { label: '✈ Telegram', color: '#3B82F6', bg: 'rgba(59,130,246,0.08)',  border: 'rgba(59,130,246,0.2)'  },
    discord:  { label: '💬 Discord', color: '#8B5CF6', bg: 'rgba(139,92,246,0.08)',  border: 'rgba(139,92,246,0.2)'  },
    website:  { label: '🌐 Website', color: '#34D399', bg: 'rgba(52,211,153,0.08)',  border: 'rgba(52,211,153,0.2)'  },
    custom:   { label: '✏️ Custom',  color: '#F59E0B', bg: 'rgba(245,158,11,0.08)',  border: 'rgba(245,158,11,0.2)'  },
};

const ACTION_LABELS = {
    follow:   'Follow',
    retweet:  'Retweet',
    like:     'Like',
    join:     'Join',
    visit:    'Visit',
    complete: 'Complete',
};

export default function EarnProject() {
    const { slug } = useParams();
    const navigate  = useNavigate();
    const [project, setProject]     = useState(null);
    const [quests, setQuests]       = useState([]);
    const [loading, setLoading]     = useState(true);
    const [error, setError]         = useState('');
    const [proofs, setProofs]       = useState({});
    const [submitStates, setSubmitStates] = useState({});

    const token = localStorage.getItem('onlineico_token');
    const isLoggedIn = !!token;

    useEffect(() => {
        getPublicQuests(slug).then(data => {
            if (data.error) { setError(data.error); }
            else {
                setProject(data.project);
                setQuests(Array.isArray(data.quests) ? data.quests : []);
                // Charger les statuts de soumission depuis l'API
                if (data.submissions) {
                    const states = {};
                    Object.entries(data.submissions).forEach(([questId, sub]) => {
                        states[questId] = sub;
                    });
                    setSubmitStates(states);
                }
            }
            setLoading(false);
        });
    }, [slug]);

    const handleSubmit = async (questId, needsProof) => {
        const proof = needsProof ? (proofs[questId] || '').trim() : '';
        if (needsProof && !proof) return;
        setSubmitStates(prev => ({ ...prev, [questId]: { status: 'sending' } }));
        const res = await submitQuestProof(questId, proof);
        if (res.success) {
            setSubmitStates(prev => ({ ...prev, [questId]: { status: 'pending' } }));
        } else {
            setSubmitStates(prev => ({ ...prev, [questId]: { status: 'error', msg: res.error } }));
        }
    };

    if (loading) return (
        <div className="app-wrap"><Navbar />
            <div style={{ textAlign: 'center', color: '#64748b', padding: '6rem' }}>Loading...</div>
        </div>
    );

    if (error || !project) return (
        <div className="app-wrap"><Navbar />
            <div style={{ textAlign: 'center', color: '#f87171', padding: '6rem' }}>Project not found.</div>
        </div>
    );

    return (
        <div className="app-wrap">


<Helmet>
    <title>{project.name ? `${project.name} Quests — Earn ${project.ticker || 'Crypto'} Rewards | OnlineICO` : 'Quests | OnlineICO'}</title>
    <meta name="description" content={`Complete quests for ${project.name} and earn ${project.ticker || 'token'} rewards. Support the project and get rewarded on OnlineICO Earn.`} />
    <link rel="canonical" href={`https://onlineico.com/earn/${slug}`} />

    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="OnlineICO" />
    <meta property="og:title" content={project.name ? `${project.name} Quests — Earn Rewards | OnlineICO` : 'Quests | OnlineICO'} />
    <meta property="og:description" content={`Complete quests for ${project.name} and earn ${project.ticker || 'token'} rewards.`} />
    <meta property="og:url" content={`https://onlineico.com/earn/${slug}`} />
    <meta property="og:image" content={project.logo_url || 'https://onlineico.com/og-image.png'} />
    <meta property="og:image:width" content="512" />
    <meta property="og:image:height" content="512" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@online_ico" />
    <meta name="twitter:title" content={project.name ? `${project.name} Quests — Earn ${project.ticker || 'Crypto'} | OnlineICO` : 'Quests | OnlineICO'} />
    <meta name="twitter:description" content={`Complete quests for ${project.name} and earn ${project.ticker || 'token'} rewards on OnlineICO.`} />
    <meta name="twitter:image" content={project.logo_url || 'https://onlineico.com/og-image.png'} />

    <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": project.name ? `${project.name} Quests | OnlineICO` : 'Quests | OnlineICO',
        "description": `Complete quests for ${project.name} and earn ${project.ticker || 'token'} rewards.`,
        "url": `https://onlineico.com/earn/${slug}`,
        "publisher": {
            "@type": "Organization",
            "name": "OnlineICO",
            "url": "https://onlineico.com",
            "logo": "https://onlineico.com/logo_onlineico_v.png"
        }
    })}</script>
</Helmet>

            <Navbar />
            <div style={{ maxWidth: '800px', margin: '0 auto', padding: '5rem 1.5rem 6rem' }}>

                {/* ── Retour ── */}
                <button onClick={() => navigate('/earn')}
                    style={{ background: 'none', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', color: '#94a3b8', padding: '7px 16px', cursor: 'pointer', fontSize: '0.82rem', fontFamily: 'Inter, sans-serif', marginBottom: '32px' }}>
                    ← Back to projects
                </button>

                {/* ── Header projet ── */}
                <div style={{ background: 'rgba(10,15,30,0.6)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '24px', padding: '28px', marginBottom: '32px', backdropFilter: 'blur(20px)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                        {project.logo_url && (
                            <img src={project.logo_url} alt={project.name}
                                style={{ width: '56px', height: '56px', borderRadius: '14px', objectFit: 'cover', flexShrink: 0 }} />
                        )}
                        <div>
                            <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '1.4rem', color: '#F1F5F9' }}>{project.name}</div>
                            <div style={{ color: '#64748b', fontSize: '0.8rem', marginTop: '2px' }}>{project.ticker} · {project.chain}</div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
                        <div style={{ background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.25)', borderRadius: '20px', padding: '4px 14px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ color: '#F59E0B', fontWeight: '700' }}>{quests.length}</span>
                            <span style={{ color: '#94a3b8', fontSize: '0.78rem' }}>quest{quests.length > 1 ? 's' : ''} available</span>
                        </div>
                        <button onClick={() => navigate(`/${project.type}/${project.slug}`)}
                            style={{ background: 'none', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', color: '#94a3b8', padding: '7px 16px', cursor: 'pointer', fontSize: '0.78rem', fontFamily: 'Inter, sans-serif' }}>
                            View project →
                        </button>
                    </div>
                </div>

                {/* ── Message si non connecté ── */}
                {!isLoggedIn && (
                    <div style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.25)', borderRadius: '16px', padding: '16px 20px', marginBottom: '24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
                        <span style={{ color: '#94a3b8', fontSize: '0.88rem' }}>🔒 Log in to participate in quests and earn points.</span>
                        <button onClick={() => navigate('/connexion')}
                            style={{ padding: '8px 20px', borderRadius: '20px', background: 'linear-gradient(135deg, #F59E0B, #EC4899)', border: 'none', color: '#0B1120', fontWeight: '700', fontSize: '0.82rem', cursor: 'pointer', fontFamily: 'Inter, sans-serif' }}>
                            Log in
                        </button>
                    </div>
                )}

                {/* ── Liste des quêtes ── */}
                {quests.length === 0 ? (
                    <div style={{ textAlign: 'center', color: '#64748b', padding: '3rem' }}>No quests available.</div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {quests.map((q, idx) => {
                            const t = PLATFORM_STYLES[q.platform] || PLATFORM_STYLES.custom;
                            const actions = Array.isArray(q.actions) ? q.actions : [];
                            const state = submitStates[q.id];
                            const status = state?.status;

                            // Grisé si pending ou approved — actif si rejected ou pas encore soumis
                            const isDone      = status === 'pending' || status === 'approved';
                            const isRejected  = status === 'rejected';
                            const cardOpacity = isDone ? 0.45 : 1;
                            // Preuve URL requise uniquement pour retweet et tweet
                            const needsProof  = actions.some(a => ['retweet', 'tweet'].includes(a));

                            return (
                                <div key={q.id} style={{ opacity: cardOpacity, transition: 'opacity 0.2s', background: 'rgba(10,15,30,0.7)', border: isDone ? '1px solid rgba(255,255,255,0.05)' : `1px solid ${t.border}`, borderRadius: '20px', overflow: 'hidden', backdropFilter: 'blur(20px)' }}>

                                    {/* En-tête quête */}
                                    <div style={{ background: isDone ? 'rgba(255,255,255,0.02)' : t.bg, padding: '18px 22px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '16px', flexWrap: 'wrap' }}>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                                                <span style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '50%', width: '26px', height: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', color: '#94a3b8', fontWeight: '700', flexShrink: 0 }}>{idx + 1}</span>
                                                <span style={{ color: isDone ? '#64748b' : '#F1F5F9', fontWeight: '700', fontSize: '1rem' }}>{q.title}</span>
                                                {/* Badge statut */}
                                                {status === 'approved' && <span style={{ fontSize: '0.7rem', color: '#34D399', background: 'rgba(52,211,153,0.1)', border: '1px solid rgba(52,211,153,0.3)', borderRadius: '20px', padding: '2px 8px', whiteSpace: 'nowrap' }}>✅ Approved</span>}
                                                {status === 'pending'  && <span style={{ fontSize: '0.7rem', color: '#F59E0B', background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.3)', borderRadius: '20px', padding: '2px 8px', whiteSpace: 'nowrap' }}>⏳ Pending</span>}
                                                {isRejected            && <span style={{ fontSize: '0.7rem', color: '#f87171', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '20px', padding: '2px 8px', whiteSpace: 'nowrap' }}>❌ Rejected</span>}
                                            </div>
                                            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                <span style={{ fontSize: '0.73rem', color: isDone ? '#475569' : t.color, fontWeight: '600', background: isDone ? 'rgba(255,255,255,0.04)' : `${t.color}20`, border: `1px solid ${isDone ? 'rgba(255,255,255,0.08)' : t.border}`, borderRadius: '20px', padding: '2px 10px' }}>{t.label}</span>
                                                {actions.map(a => (
                                                    <span key={a} style={{ fontSize: '0.73rem', color: '#475569', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)', borderRadius: '20px', padding: '2px 10px' }}>{ACTION_LABELS[a] || a}</span>
                                                ))}
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px', flexShrink: 0 }}>
                                            <div style={{ textAlign: 'right' }}>
                                                <div style={{ color: isDone ? '#475569' : '#F59E0B', fontFamily: 'Syne, sans-serif', fontWeight: '800', fontSize: '1rem' }}>{q.reward}</div>
                                                <div style={{ color: '#475569', fontSize: '0.7rem' }}>+{q.points} pts</div>
                                            </div>
                                            {!isDone && (
                                                <a href={q.url} target="_blank" rel="noopener noreferrer"
                                                    style={{ padding: '7px 16px', borderRadius: '20px', background: t.color, color: '#0B1120', fontWeight: '700', fontSize: '0.78rem', textDecoration: 'none', whiteSpace: 'nowrap', fontFamily: 'Inter, sans-serif' }}>
                                                    Lien →
                                                </a>
                                            )}
                                        </div>
                                    </div>

                                    {/* Zone soumission */}
                                    <div style={{ padding: '14px 22px', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
                                        {!isLoggedIn ? (
                                            <p style={{ color: '#475569', fontSize: '0.82rem', margin: 0 }}>Log in to submit your proof.</p>
                                        ) : status === 'approved' ? (
                                            <span style={{ color: '#34D399', fontSize: '0.82rem', fontWeight: '600' }}>✅ +{q.points} pts credited to your account</span>
                                        ) : status === 'pending' ? (
                                            <span style={{ color: '#F59E0B', fontSize: '0.82rem' }}>⏳ Proof submitted — awaiting validation by the project</span>
                                        ) : (
                                            // Formulaire : visible si pas soumis ou si rejeté
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                {isRejected && state?.rejection_reason && (
                                                    <div style={{ color: '#f87171', fontSize: '0.8rem', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: '8px', padding: '8px 12px' }}>
                                                        ❌ Rejected — reason: <strong>{state.rejection_reason}</strong>. You can resubmit below.
                                                    </div>
                                                )}
                                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                                                    {needsProof && (
                                                        <input
                                                            value={proofs[q.id] || ''}
                                                            onChange={e => setProofs(prev => ({ ...prev, [q.id]: e.target.value }))}
                                                            placeholder="Paste the URL of your post..."
                                                            style={{ flex: 1, minWidth: '200px', padding: '9px 14px', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', color: '#F1F5F9', fontSize: '0.85rem', fontFamily: 'Inter, sans-serif', outline: 'none' }}
                                                        />
                                                    )}
                                                    <button
                                                        onClick={() => handleSubmit(q.id, needsProof)}
                                                        disabled={status === 'sending' || (needsProof && !proofs[q.id]?.trim())}
                                                        style={{ padding: '9px 20px', borderRadius: '10px', background: 'linear-gradient(135deg, #8B5CF6, #6D28D9)', border: 'none', color: '#fff', fontWeight: '700', fontSize: '0.82rem', cursor: 'pointer', fontFamily: 'Inter, sans-serif', whiteSpace: 'nowrap', opacity: (status === 'sending' || (needsProof && !proofs[q.id]?.trim())) ? 0.5 : 1 }}>
                                                        {status === 'sending' ? '...' : '🚀 Submit'}
                                                    </button>
                                                </div>
                                                {status === 'error' && (
                                                    <span style={{ color: '#f87171', fontSize: '0.8rem' }}>{state.msg}</span>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}
